// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1l2mb","title":"ClientReferral_title__1wlcD","itemText":"ClientReferral_itemText__djkSY"};